import React from 'react';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import logo from '../../public/static/images/logo.png';
import { BFIslandButton, BFIslandColors } from '@buzzfeed/react-components';
import { ITUNES_APP_URL } from '../../constants';
import { useTrackingContext } from '../../hooks';

const Navbar = ({ isHomepage = false }) => {
  const router = useRouter();
  const { trackExternalLink, trackInternalLink } = useTrackingContext();

  const commonTrackingData = {
    unit_type: 'nav',
    unit_name: 'main',
    item_type: 'button',
  };

  const handleGetIslandClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    trackExternalLink({
      ...commonTrackingData,
      item_name: 'get_island',
      position_in_unit: 1,
      target_content_url: ITUNES_APP_URL,
    });

    window.open(`${ITUNES_APP_URL}?pt=329394&ct=bfidc_nav&mt=8`, '_blank', 'noopener,noreferrer');
  };

  const handleLogoClick = () => {
    if (!isHomepage) {
      trackInternalLink({
        ...commonTrackingData,
        item_name: 'home',
        position_in_unit: 0,
        target_content_type: 'utility',
        target_content_id: 'home',
      });

      // Navigate to homepage
      router.push('/');
    }
  };

  return (
    <div className={styles.navbar} role="banner">
      <div className={styles.logoWrapper} onClick={handleLogoClick}>
        <img className={styles.logo} src={logo} alt="Island logo" />
      </div>
      <BFIslandButton
        className={styles.button}
        onClick={handleGetIslandClick}
        text="Get island"
        size="small"
        responsive
        bgColor={BFIslandColors.LIME}
      />
    </div>
  );
};

export default Navbar;
